/**
 * Constants for Emilio's Solutions
 */
export const BRAND = {
  name: "Emilio's Solutions",
  tagline: "Cleaning Done Right",
  uen: "53467871L",
  phone: "+65 8416 2604",
  phoneRaw: "6584162604",
  whatsapp: "https://wa.me/6584162604",
  email: "emiliosolutions@gmail.com",
  serviceArea: "Singapore",
  stats: {
    jobs: "5,000+",
    rating: 4.9,
    reviewCount: 230,
  },
  logo:
    "https://customer-assets-jai6qajn.emergentagent.net/job_e7f69da0-3723-4f75-89ff-d3b9cf50eb22/artifacts/v87dxhmp__Emilio%20Solutions%20-%20Logo%20Only%20Full%20Color.webp",
};

export const DEFAULT_WA_MESSAGE =
  "Hi Emilio's Solutions, I would like to request a quotation for a cleaning service.";
